import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarConfiguraciones } from "../services/configuraciones-service";

/** Query options compartidas entre el loader del route y el componente. */
export const configuracionesAdminQueryOptions = queryOptions({
  queryKey: qk.adminConfiguraciones,
  queryFn: listarConfiguraciones,
});

export function useConfiguracionesAdmin() {
  return useSuspenseQuery(configuracionesAdminQueryOptions);
}
